import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SocialStepFail", "User did not view the stim", config.defaultMessageId )